import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CustomQuestion } from '../models/custom-question.model';
import { LocaleService } from './locale.service';
import { RequestService } from './request.service';
import { CallRateRequest } from '../models/call-rate-request.model';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RatingService {
  private readonly httpClient = inject(HttpClient);
  private readonly requestService = inject(RequestService);
  private readonly localeService = inject(LocaleService);

  getDefaultCustomQuestions(): Promise<CustomQuestion[]> {
    return firstValueFrom(this.httpClient.get<CustomQuestion[]>('assets/data/default-questions.data.json'));
  }

  getSatisfactorySurveyQuestions(providerId: string, localeCode = this.localeService.languageCode): Promise<CustomQuestion[]> {
    return this.requestService.get(`/provider/${providerId}/satisfactorySurveyQuestions?localeCode=${localeCode}`);
  }

  rateCall(rateRequest: CallRateRequest, callId: string, executeNow = false): Promise<void> {
    const body = { ...rateRequest, executeNow };
    if (!rateRequest.questions) {
      return this.requestService.put(`/call/${callId}/rate`, body);
    } else {
      return this.rateCustomQuestions(rateRequest);
    }
  }

  registerMedicalCareRecord(callId: string): Promise<void> {
    return this.requestService.post('/call/medicalCareRecord', { callId });
  }

  isCallRated(callId: string): Promise<boolean> {
    return this.requestService.get(`/call/${callId}/isCallRated`);
  }

  private rateCustomQuestions(rateRequest: CallRateRequest): Promise<void> {
    return this.requestService.post(`/satisfactionSurveyAnswers`, rateRequest);
  }
}
